import {
  BookIcon,
  PairsIcon,
  HebrewIcon,
  GreekIcon,
  NumbersIcon,
  SortIcon,
  TestamentIcon,
  VerseIcon,
  QuoteIcon,
  CrownIcon,
  GeographyIcon,
  LocatorIcon,
  ParablesIcon,
  TimelineIcon,
  MiraclesIcon,
  ProverbsIcon,
  OccupationsIcon,
  PromisesIcon,
  ApostlesIcon,
  AnimalsIcon,
  PlantsIcon,
  WatersIcon,
  CitiesIcon,
  FoodsIcon,
  FeastsIcon,
  CommandmentsIcon,
  MountainsIcon,
  DreamsIcon,
  BattlesIcon,
  CovenantsIcon,
  SongsIcon,
  ClothingIcon,
  NationsIcon,
  MatchIcon,
  SequenceIcon,
  SwipeIcon,
  HangmanIcon,
  MemoryIcon,
  PrayersIcon,
  FamiliesIcon,
  OddOneOutIcon,
  ChainIcon,
  ScenesIcon,
  PuzzleGameIcon,
} from '../utils/icons';

const games = [
  {
    id: 'anagram-guess',
    mechanic: 'unscramble',
    titleKey: 'games.anagramGuess.title',
    descriptionKey: 'games.anagramGuess.description',
    icon: BookIcon,
    loader: () => import('./anagram-guess'),
  },
  {
    id: 'bible-pairs',
    mechanic: 'type',
    titleKey: 'games.biblePairs.title',
    descriptionKey: 'games.biblePairs.description',
    icon: PairsIcon,
    loader: () => import('./bible-pairs'),
  },
  {
    id: 'hebrew-alphabet',
    mechanic: 'quiz',
    titleKey: 'games.hebrewAlpha.title',
    descriptionKey: 'games.hebrewAlpha.description',
    icon: HebrewIcon,
    loader: () => import('./hebrew-alphabet'),
  },
  {
    id: 'greek-alphabet',
    mechanic: 'quiz',
    titleKey: 'games.greekAlpha.title',
    descriptionKey: 'games.greekAlpha.description',
    icon: GreekIcon,
    loader: () => import('./greek-alphabet'),
  },
  {
    id: 'bible-numbers',
    mechanic: 'type',
    titleKey: 'games.bibleNumbers.title',
    descriptionKey: 'games.bibleNumbers.description',
    icon: NumbersIcon,
    loader: () => import('./bible-numbers'),
  },
  {
    id: 'books-sort',
    mechanic: 'sort',
    titleKey: 'games.booksSort.title',
    descriptionKey: 'games.booksSort.description',
    icon: SortIcon,
    loader: () => import('./books-sort'),
  },
  {
    id: 'old-or-new',
    mechanic: 'binary',
    titleKey: 'games.oldOrNew.title',
    descriptionKey: 'games.oldOrNew.description',
    icon: TestamentIcon,
    loader: () => import('./old-or-new'),
  },
  {
    id: 'missing-word',
    mechanic: 'quiz',
    titleKey: 'games.missingWord.title',
    descriptionKey: 'games.missingWord.description',
    icon: VerseIcon,
    loader: () => import('./missing-word'),
  },
  {
    id: 'who-said-it',
    mechanic: 'quiz',
    titleKey: 'games.whoSaidIt.title',
    descriptionKey: 'games.whoSaidIt.description',
    icon: QuoteIcon,
    loader: () => import('./who-said-it'),
  },
  {
    id: 'kings-prophets',
    mechanic: 'quiz',
    titleKey: 'games.kingsProphets.title',
    descriptionKey: 'games.kingsProphets.description',
    icon: CrownIcon,
    loader: () => import('./kings-prophets'),
  },
  {
    id: 'bible-geography',
    mechanic: 'quiz',
    titleKey: 'games.bibleGeo.title',
    descriptionKey: 'games.bibleGeo.description',
    icon: GeographyIcon,
    loader: () => import('./bible-geography'),
  },
  {
    id: 'verse-locator',
    mechanic: 'quiz',
    titleKey: 'games.verseLocator.title',
    descriptionKey: 'games.verseLocator.description',
    icon: LocatorIcon,
    loader: () => import('./verse-locator'),
  },
  {
    id: 'parables-quiz',
    mechanic: 'quiz',
    titleKey: 'games.parablesQuiz.title',
    descriptionKey: 'games.parablesQuiz.description',
    icon: ParablesIcon,
    loader: () => import('./parables-quiz'),
  },
  {
    id: 'bible-timeline',
    mechanic: 'sort',
    titleKey: 'games.bibleTimeline.title',
    descriptionKey: 'games.bibleTimeline.description',
    icon: TimelineIcon,
    loader: () => import('./bible-timeline'),
  },
  {
    id: 'miracles-quiz',
    mechanic: 'quiz',
    titleKey: 'games.miraclesQuiz.title',
    descriptionKey: 'games.miraclesQuiz.description',
    icon: MiraclesIcon,
    loader: () => import('./miracles-quiz'),
  },
  {
    id: 'proverbs-match',
    mechanic: 'quiz',
    titleKey: 'games.proverbsMatch.title',
    descriptionKey: 'games.proverbsMatch.description',
    icon: ProverbsIcon,
    loader: () => import('./proverbs-match'),
  },
  {
    id: 'bible-occupations',
    mechanic: 'type',
    titleKey: 'games.bibleOccupations.title',
    descriptionKey: 'games.bibleOccupations.description',
    icon: OccupationsIcon,
    loader: () => import('./bible-occupations'),
  },
  {
    id: 'promises-of-god',
    mechanic: 'quiz',
    titleKey: 'games.promisesOfGod.title',
    descriptionKey: 'games.promisesOfGod.description',
    icon: PromisesIcon,
    loader: () => import('./promises-of-god'),
  },
  {
    id: 'apostles-quiz',
    mechanic: 'quiz',
    titleKey: 'games.apostlesQuiz.title',
    descriptionKey: 'games.apostlesQuiz.description',
    icon: ApostlesIcon,
    loader: () => import('./apostles-quiz'),
  },
  {
    id: 'bible-animals',
    mechanic: 'quiz',
    titleKey: 'games.bibleAnimals.title',
    descriptionKey: 'games.bibleAnimals.description',
    icon: AnimalsIcon,
    loader: () => import('./bible-animals'),
  },
  {
    id: 'bible-plants',
    mechanic: 'unscramble',
    titleKey: 'games.biblePlants.title',
    descriptionKey: 'games.biblePlants.description',
    icon: PlantsIcon,
    loader: () => import('./bible-plants'),
  },
  {
    id: 'bible-waters',
    mechanic: 'quiz',
    titleKey: 'games.bibleWaters.title',
    descriptionKey: 'games.bibleWaters.description',
    icon: WatersIcon,
    loader: () => import('./bible-waters'),
  },
  {
    id: 'bible-cities',
    mechanic: 'unscramble',
    titleKey: 'games.bibleCities.title',
    descriptionKey: 'games.bibleCities.description',
    icon: CitiesIcon,
    loader: () => import('./bible-cities'),
  },
  {
    id: 'bible-foods',
    mechanic: 'quiz',
    titleKey: 'games.bibleFoods.title',
    descriptionKey: 'games.bibleFoods.description',
    icon: FoodsIcon,
    loader: () => import('./bible-foods'),
  },
  {
    id: 'bible-feasts',
    mechanic: 'quiz',
    titleKey: 'games.bibleFeasts.title',
    descriptionKey: 'games.bibleFeasts.description',
    icon: FeastsIcon,
    loader: () => import('./bible-feasts'),
  },
  {
    id: 'bible-commandments',
    mechanic: 'quiz',
    titleKey: 'games.bibleCommandments.title',
    descriptionKey: 'games.bibleCommandments.description',
    icon: CommandmentsIcon,
    loader: () => import('./bible-commandments'),
  },
  {
    id: 'bible-mountains',
    mechanic: 'quiz',
    titleKey: 'games.bibleMountains.title',
    descriptionKey: 'games.bibleMountains.description',
    icon: MountainsIcon,
    loader: () => import('./bible-mountains'),
  },
  {
    id: 'bible-dreams',
    mechanic: 'quiz',
    titleKey: 'games.bibleDreams.title',
    descriptionKey: 'games.bibleDreams.description',
    icon: DreamsIcon,
    loader: () => import('./bible-dreams'),
  },
  {
    id: 'bible-battles',
    mechanic: 'quiz',
    titleKey: 'games.bibleBattles.title',
    descriptionKey: 'games.bibleBattles.description',
    icon: BattlesIcon,
    loader: () => import('./bible-battles'),
  },
  {
    id: 'bible-covenants',
    mechanic: 'quiz',
    titleKey: 'games.bibleCovenants.title',
    descriptionKey: 'games.bibleCovenants.description',
    icon: CovenantsIcon,
    loader: () => import('./bible-covenants'),
  },
  {
    id: 'bible-songs',
    mechanic: 'quiz',
    titleKey: 'games.bibleSongs.title',
    descriptionKey: 'games.bibleSongs.description',
    icon: SongsIcon,
    loader: () => import('./bible-songs'),
  },
  {
    id: 'bible-clothing',
    mechanic: 'quiz',
    titleKey: 'games.bibleClothing.title',
    descriptionKey: 'games.bibleClothing.description',
    icon: ClothingIcon,
    loader: () => import('./bible-clothing'),
  },
  {
    id: 'bible-nations',
    mechanic: 'type',
    titleKey: 'games.bibleNations.title',
    descriptionKey: 'games.bibleNations.description',
    icon: NationsIcon,
    loader: () => import('./bible-nations'),
  },
  {
    id: 'bible-tribes-match',
    mechanic: 'match',
    titleKey: 'games.bibleTribesMatch.title',
    descriptionKey: 'games.bibleTribesMatch.description',
    icon: MatchIcon,
    loader: () => import('./bible-tribes-match'),
  },
  {
    id: 'verse-builder',
    mechanic: 'sequence',
    titleKey: 'games.verseBuilder.title',
    descriptionKey: 'games.verseBuilder.description',
    icon: SequenceIcon,
    loader: () => import('./verse-builder'),
  },
  {
    id: 'true-or-false',
    mechanic: 'swipe',
    titleKey: 'games.trueOrFalse.title',
    descriptionKey: 'games.trueOrFalse.description',
    icon: SwipeIcon,
    loader: () => import('./true-or-false'),
  },
  {
    id: 'bible-hangman',
    mechanic: 'hangman',
    titleKey: 'games.bibleHangman.title',
    descriptionKey: 'games.bibleHangman.description',
    icon: HangmanIcon,
    loader: () => import('./bible-hangman'),
  },
  {
    id: 'bible-memory',
    mechanic: 'memory',
    titleKey: 'games.bibleMemory.title',
    descriptionKey: 'games.bibleMemory.description',
    icon: MemoryIcon,
    loader: () => import('./bible-memory'),
  },
  {
    id: 'bible-prayers',
    mechanic: 'match',
    titleKey: 'games.biblePrayers.title',
    descriptionKey: 'games.biblePrayers.description',
    icon: PrayersIcon,
    loader: () => import('./bible-prayers'),
  },
  {
    id: 'bible-families',
    mechanic: 'type',
    titleKey: 'games.bibleFamilies.title',
    descriptionKey: 'games.bibleFamilies.description',
    icon: FamiliesIcon,
    loader: () => import('./bible-families'),
  },
  {
    id: 'odd-one-out',
    mechanic: 'quiz',
    titleKey: 'games.oddOneOut.title',
    descriptionKey: 'games.oddOneOut.description',
    icon: OddOneOutIcon,
    loader: () => import('./odd-one-out'),
  },
  {
    id: 'bible-chain',
    mechanic: 'chain',
    titleKey: 'games.bibleChain.title',
    descriptionKey: 'games.bibleChain.description',
    icon: ChainIcon,
    loader: () => import('./bible-chain'),
  },
  {
    id: 'bible-scenes',
    mechanic: 'quiz',
    titleKey: 'games.bibleScenes.title',
    descriptionKey: 'games.bibleScenes.description',
    icon: ScenesIcon,
    loader: () => import('./bible-scenes'),
  },
  {
    id: 'bible-puzzle',
    mechanic: 'puzzle',
    titleKey: 'games.biblePuzzle.title',
    descriptionKey: 'games.biblePuzzle.description',
    icon: PuzzleGameIcon,
    loader: () => import('./bible-puzzle'),
  },
];

export default games;
